<div class="footercontact">
</div>
<div class="w-container hidden-md-down">
    <div class="w-row">

      <div class="w-col">
        <div class="w-row">
          <div class="column-6 w-col w-col-4 w-col-small-4 w-col-tiny-6">
            <h4 class="heading-5">INFORMATION</h4>

            <a style="color: #9b7544;" routerLink="/policies/1"> About Petcart </a>
            <a  style="color: #9b7544;" routerLink="/policies/2"> Contact Us </a>
            <a  style="color: #9b7544;" routerLink="/policies/3"> Terms & Conditions </a>
            <a  style="color: #9b7544;" routerLink="/policies/4"> Privacy Policy </a>
            <a  style="color: #9b7544;" routerLink="/policies/5"> Disclaimer Policy </a>
            <a  style="color: #9b7544;" routerLink="/policies/6"> Cancellation & Refund Policy </a>
            <a  style="color: #9b7544;" routerLink="/policies/7"> Shipping and Delivery Policy </a>
          </div>






            <div class="column-9 w-col w-col-3 w-col-small-3 w-col-tiny-6">

              <a href="https://play.google.com/store/apps/details?id=com.petcart" class="footer-links"><img src="\assets\images\googleapp.png" style="height: 73px; width: 195px; margin-left: -11px;"></a>


            <a href="https://itunes.apple.com/us/app/petcart/id1079875538" class="footer-links"><img src="\assets\images\iosapp.png" style="height: 50px; width: 172px;"></a>

          </div>
        </div>
      </div>
    </div>


  </div>
